/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalCoverageDetail
 */
export interface AdditionalCoverageDetail {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    value?: string;
}

/**
 * Check if a given object implements the AdditionalCoverageDetail interface.
 */
export function instanceOfAdditionalCoverageDetail(value: object): value is AdditionalCoverageDetail {
    return true;
}

export function AdditionalCoverageDetailFromJSON(json: any): AdditionalCoverageDetail {
    return AdditionalCoverageDetailFromJSONTyped(json, false);
}

export function AdditionalCoverageDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalCoverageDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function AdditionalCoverageDetailToJSON(json: any): AdditionalCoverageDetail {
    return AdditionalCoverageDetailToJSONTyped(json, false);
}

export function AdditionalCoverageDetailToJSONTyped(value?: AdditionalCoverageDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

